<template>
	<AdminPageLayout :loading="loading" :error="error">
		<table class="generic-table">
				<thead>
					<tr>
						<th>Email</th>
						<th>Created</th>
						<th>Admin</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="user in users" :key="user.user_id">
						<td>{{ user.email }}</td>
						<td>{{ $formatDate(user.created) }}</td>
						<td>{{ user.is_admin}}</td>
						<td>
							<div class="generic-table-actions">
								<button 
									@click="deleteUser(user.user_id)"
									class="generic-table-action-button"
									:disabled="action_loading || user.is_admin"
								>
									Delete
								</button>
							</div>
						</td>
					</tr>
				</tbody>
		</table>
	</AdminPageLayout>
</template>

<script>
import AdminPageLayout from './_PageLayout.vue'

export default {
	name: 'Users',
	components: {
		AdminPageLayout
	},
	data() {
		return {
			loading: true,
			action_loading: false,
			error: '',
			users: []
		}
	},
	async mounted() {
		await this.fetchUsers()
	},
	methods: {
		async fetchUsers() {
			this.loading = true
			this.error = ''

			const authToken = localStorage.getItem('authToken')?.trim()
			if (!authToken || authToken === 'null') {
				this.$router.push({ name: 'Login' })
				return
			}
			
			try {
				const response = await this.$api.post('/api/admin/users', {
					authToken: authToken
				})
				
				this.users = response.data.users || []
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else {
					this.error = 'An error occurred while loading users.'
					console.error('Error:', error)
				}
			} finally {
				this.loading = false
			}
		},
		async deleteUser(userId) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/users/delete', {
					authToken: authToken,
					userId: userId
				})
				await this.fetchUsers()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'User not found.'
				} else {
					this.error = error
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		}
	}
}
</script>

<style scoped>
</style>

